module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "title": "添加基础物料，方便您个性化的添加各类服务商品(不仅仅是商品)！",
      "type": "warning",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addServiceLabels
    }
  }, [_vm._v("添加基础物料")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "基础物料名称",
      "size": "mini"
    },
    model: {
      value: (_vm.labelsName),
      callback: function($$v) {
        _vm.labelsName = $$v
      },
      expression: "labelsName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.labelsSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.serviceLabelsList,
      "height": _vm.wheight - 270
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "labelName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "serviceType",
      "label": "系统类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.serviceType === 'point') ? _c('span', [_vm._v("积分")]) : _vm._e(), _vm._v(" "), (scope.row.serviceType === 'deposit') ? _c('span', [_vm._v("储值")]) : _vm._e(), _vm._v(" "), (scope.row.serviceType === 'timescard') ? _c('span', [_vm._v("次卡")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "labelPrice",
      "label": "物料价格(元)",
      "formatter": _vm.priceformatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-search-plus",
          on: {
            "click": function($event) {
              return _vm.serviceLabelsDetail(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editServiceLabelsAction(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteServiceLabelsAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editServiceLabelsTitle,
      "visible": _vm.editServiceLabelsVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.editServiceLabelsVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "90px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "系统类型"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-select', {
      model: {
        value: (_vm.form.service_type),
        callback: function($$v) {
          _vm.$set(_vm.form, "service_type", $$v)
        },
        expression: "form.service_type"
      }
    }, _vm._l((_vm.serviceTypes), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "物料名称"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 20,
        "placeholder": "基础物料名称，如 积分、预存款、经验值、佣金等等"
      },
      model: {
        value: (_vm.form.label_name),
        callback: function($$v) {
          _vm.$set(_vm.form, "label_name", $$v)
        },
        expression: "form.label_name"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "物料价格"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "required": "",
        "min": "0",
        "placeholder": "基础物料的价格"
      },
      model: {
        value: (_vm.form.label_price),
        callback: function($$v) {
          _vm.$set(_vm.form, "label_price", $$v)
        },
        expression: "form.label_price"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_vm._v("\n         元\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "物料描述"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "maxlength": 255
      },
      model: {
        value: (_vm.form.label_desc),
        callback: function($$v) {
          _vm.$set(_vm.form, "label_desc", $$v)
        },
        expression: "form.label_desc"
      }
    })], 1)], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitServiceLabelsAction
      }
    }, [_vm._v("保存")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "基础物料详情",
      "visible": _vm.serviceLabelsDetailVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.serviceLabelsDetailVisible = $event
      }
    }
  }, [
    [_c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("基础类型")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(_vm.serviceLabelsDetailData.service_type === 'point') ? _c('div', [_vm._v("\n            积分类型\n          ")]) : _vm._e(), _vm._v(" "), (_vm.serviceLabelsDetailData.service_type === 'deposit') ? _c('div', [_vm._v("\n            储值类型\n          ")]) : _vm._e(), _vm._v(" "), (_vm.serviceLabelsDetailData.service_type === 'timescard') ? _c('div', [_vm._v("\n            次卡类型\n          ")]) : _vm._e()])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("物料名称")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.serviceLabelsDetailData.label_name))])])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("物料价格")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.serviceLabelsDetailData.label_price))])])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("物料描述")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.serviceLabelsDetailData.label_desc))])])], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          _vm.serviceLabelsDetailVisible = false;
          _vm.serviceLabelsDetailData = {}
        }
      }
    }, [_vm._v("取消")])], 1)
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-12258544", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12258544"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/service/servicelabels/list.vue
// module id = 2478
// module chunks = 0